import React from 'react';

type PolygonDiverColor = 'green' | 'indigo' | 'yellow' | 'gray';

interface PolygonDividerProps {
  children: React.ReactNode;
  color?: PolygonDiverColor;
  withBorder?: boolean;
  isDark?: boolean;
}

const PolygonDivider: React.FC<PolygonDividerProps> = ({ children, color, withBorder, isDark }) => {
  const textColor = () => {
    switch (color) {
      case 'green':
        return 'text-green-400';
      case 'indigo':
        return 'text-indigo-400';
      case 'yellow':
        return 'text-yellow-400';
      default:
        return 'text-gray-400';
    }
  };

  return (
    <div className="flex items-center w-full">
      {/* 左の線 */}
      {withBorder && (
        <div
          className={`flex-grow h-[1px] bg-gradient-to-l ${isDark ? 'from-gray-800 to-gray-700' : 'from-gray-300 to-gray-100'} rounded-full`}
        />
      )}

      {/* 六角形のラベル */}
      <div className="relative mx-1">
        <div
          className={`flex items-center px-4 py-[2px] ${isDark ? 'bg-gray-800' : 'bg-gray-200'} ${textColor()} font-footballlog font-semibold italic text-sm relative z-0`}
          style={{
            clipPath: 'polygon(10% 0%, 90% 0%, 100% 50%, 90% 100%, 10% 100%, 0% 50%)'
          }}>
          {children}
        </div>
      </div>

      {/* 右の線 */}
      {withBorder && (
        <div
          className={`flex-grow h-[1px] bg-gradient-to-r ${isDark ? 'from-gray-800 to-gray-700' : 'from-gray-300 to-gray-100'} rounded-full`}
        />
      )}
    </div>
  );
};

export default PolygonDivider;
